import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiChevronDown, FiChevronUp } = FiIcons;

const FAQ = () => {
  const [openItems, setOpenItems] = useState({});

  const toggleItem = (index) => {
    setOpenItems(prev => ({
      ...prev,
      [index]: !prev[index]
    }));
  };

  const faqItems = [
    {
      question: "How much is £40,000 after tax in the UK?",
      answer: "A £40,000 salary in England/Wales/Northern Ireland results in approximately £32,320 take-home pay annually, or £2,693 per month after income tax (£5,486) and National Insurance (£2,194) deductions."
    },
    {
      question: "What is monthly take-home pay on £35k?",
      answer: "A £35,000 salary gives you approximately £28,720 annually or £2,393 monthly take-home pay after income tax (£4,486) and National Insurance (£1,794) in England, Wales, and Northern Ireland."
    },
    {
      question: "Do I pay student loan on my salary?",
      answer: "You pay student loan repayments if your salary exceeds the threshold for your plan: Plan 1 (£22,015), Plan 2 (£27,295), Plan 4 (£27,660), Plan 5 (£25,000), or Postgraduate (£21,000). The repayment rate is 9% of income above the threshold (6% for Postgraduate loans)."
    },
    {
      question: "How does Scotland tax differ from England?",
      answer: "Scotland has different income tax rates and bands. For 2025/26, Scotland has a starter rate of 19% (£12,571-£14,876), basic rate of 20% (£14,877-£26,561), intermediate rate of 21% (£26,562-£43,662), higher rate of 42% (£43,663-£75,000), advanced rate of 45% (£75,001-£125,140), and top rate of 48% (over £125,140)."
    },
    {
      question: "How is National Insurance calculated?",
      answer: "National Insurance Class 1 contributions are 8% on earnings between £12,570 and £50,270, then 2% on earnings above £50,270. There's no National Insurance on earnings below £12,570. Rates were reduced from 12% to 8% in 2024."
    },
    {
      question: "What is the personal allowance for 2025/26?",
      answer: "The personal allowance for 2025/26 is £12,570, meaning you don't pay income tax on the first £12,570 of your earnings. This allowance is reduced by £1 for every £2 earned above £100,000."
    },
    {
      question: "How much pension should I contribute?",
      answer: "The minimum auto-enrolment pension contribution is 8% (5% employee, 3% employer). Many financial advisors suggest contributing 10-15% of your salary for a comfortable retirement, including employer contributions."
    },
    {
      question: "When do I pay higher rate tax?",
      answer: "You pay higher rate tax (40%) on earnings above £50,270 in England, Wales, and Northern Ireland. In Scotland, higher rate tax (42%) applies to earnings above £43,662."
    },
    {
      question: "Is overtime taxed differently?",
      answer: "No, overtime is taxed the same as regular income. It's added to your annual earnings and taxed according to the same income tax and National Insurance rates."
    },
    {
      question: "How accurate are these calculations?",
      answer: "These calculations use official HMRC rates for 2025/26 and are accurate for most employees. However, they don't account for benefits in kind, company cars, or other complex tax situations. Always consult HMRC or a tax advisor for specific circumstances."
    }
  ];

  return (
    <motion.section 
      className="bg-white rounded-xl p-6 md:p-8 shadow-sm border"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.6 }}
    >
      <h2 className="text-2xl font-semibold text-gray-900 mb-6">Frequently Asked Questions</h2>
      
      <div className="space-y-4">
        {faqItems.map((item, index) => (
          <div key={index} className="border border-gray-200 rounded-lg">
            <button
              onClick={() => toggleItem(index)}
              className="w-full px-6 py-4 text-left flex justify-between items-center hover:bg-gray-50 transition-colors"
            >
              <h3 className="font-medium text-gray-900 pr-4">{item.question}</h3>
              <SafeIcon 
                icon={openItems[index] ? FiChevronUp : FiChevronDown} 
                className="text-gray-500 flex-shrink-0" 
              />
            </button>
            
            <AnimatePresence>
              {openItems[index] && (
                <motion.div
                  initial={{ height: 0, opacity: 0 }}
                  animate={{ height: 'auto', opacity: 1 }}
                  exit={{ height: 0, opacity: 0 }}
                  transition={{ duration: 0.3 }}
                  className="overflow-hidden"
                >
                  <div className="px-6 pb-4 text-gray-700">
                    {item.answer}
                  </div>
                </motion.div>
              )}
            </AnimatePresence>
          </div>
        ))}
      </div>
    </motion.section>
  );
};

export default FAQ;